import { useState, useEffect } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import logo from "./Images/harita.png";

const InventorControlPanel = () => {
  
  const baseUrl = "http://localhost:5000";

  //#region state variables
  const [agentStatus, setAgentStatus] = useState("...");
  const [invStatus, setInvStatus] = useState("...");
  const [showInstallMsg, setShowInstallMsg] = useState(false);

  const [drawc, setDrawC] = useState();
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [cylDiameter, setCylDiameter] = useState("");
  const [cylHeight, setCylHeight] = useState("");

  const [outerDia, setOuterDia] = useState("");
  const [innerDia, setInnerDia] = useState("");
  const [pipeHeight, setPipeHeight] = useState("");

  const [passwordInput, setPasswordInput] = useState("");
  const [showContent, setShowContent] = useState(false);
  //#endregion state variables

  const password = (txt) => {
    if (txt === "1234" || txt === "1212") {
      setShowContent(true);
    } else {
      setShowContent(false);
      alert("Wrong Password");
    }
  };

  useEffect(() => {
    const pingAgent = async () => {
      try {
        const res = await fetch(`${baseUrl}/status-inventor`);
        if (!res.ok) throw new Error();
      } catch (err) {
        setShowInstallMsg(true);
        setAgentStatus(
          "❌ Application not detected. Please install the setup file."
        );
      }
    };

    pingAgent();
  }, []);

  //#region API Calls

  const downloadAgent = async () => {
    try {
      const res = await fetch(`${baseUrl}/status-inventor`);
      if (res.ok) {
        setAgentStatus("✅ Application is already running.");
        return;
      }
    } catch {}

    // Proceed to download
    const link = document.createElement("a");
    link.href =
      "https://drive.google.com/file/d/1GJCfkieWB673q3N2SNTzB0MulQCMmTEx/view?usp=sharing";
    link.target = "_blank";
    link.download = "One-time Setup.exe";
    document.body.appendChild(link);
    link.click();
  };

  const checkAgent = async () => {
    try {
      const res = await fetch(`${baseUrl}/status-inventor`);
      if (res.ok) {
        setAgentStatus("✅ Application is running on localhost.");
      } else {
        setAgentStatus("⚠️ Application responded with an error.");
      }
    } catch {
      setAgentStatus(
        "❌ Could not connect to Application. Please ensure it is running."
      );
    }
  };

  const checkInventor = async () => {
    try {
      const res = await fetch(`${baseUrl}/status-inventor`);
      const data = await res.json();
      setInvStatus(
        data.installed
          ? "✅ Autodesk Inventor is installed."
          : "❌ Autodesk Inventor is not found."
      );
    } catch {
      setInvStatus("⚠️ Could not connect to the Application.");
    }
  };

  const launchInventor = async () => {
    try {
      const res = await fetch(`${baseUrl}/launch-inventor`);
      const data = await res.json();
      setInvStatus(
        data.launched
          ? "✅ Inventor launched successfully!"
          : "❌ Failed to launch Inventor / Install Inventor."
      );
    } catch {
      setInvStatus("⚠️ Could not connect to the Application.");
    }
  };

  const drawCircle = async () => {
    try {
      const res = await fetch(`${baseUrl}/draw-circle`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ diameter: parseFloat(drawc) }),
      });
      const data = await res.json();

      if (data.success) {
        alert("✅ Circle drawn successfully in Inventor!");
      } else {
        alert(`❌ Failed to draw circle: ${data.error}`);
      }
    } catch (err) {
      alert("⚠️ Could not connect to the Application.");
    }
  };

  const drawRectangle = async () => {
    try {
      const res = await fetch(`${baseUrl}/draw-rectangle`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          width: parseFloat(width),
          height: parseFloat(height),
        }),
      });

      const data = await res.json();

      if (data.success) {
        alert("✅ Rectangle drawn successfully in Inventor!");
      } else {
        alert(`❌ Failed to draw rectangle: ${data.error}`);
      }
    } catch (err) {
      alert("⚠️ Could not connect to the Application.");
    }
  };

  const drawCylinder = async () => {
    try {
      const res = await fetch(`${baseUrl}/draw-cylinder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          diameter: parseFloat(cylDiameter),
          height: parseFloat(cylHeight),
        }),
      });

      const data = await res.json();
      if (data.success) {
        alert("✅ Cylinder drawn successfully!");
      } else {
        alert(`❌ Failed to draw cylinder: ${data.error}`);
      }
    } catch {
      alert("⚠️ Could not connect to the Application.");
    }
  };

  const drawPipe = async () => {
    try {
      const res = await fetch(`${baseUrl}/draw-pipe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          outerDiameter: parseFloat(outerDia),
          innerDiameter: parseFloat(innerDia),
          height: parseFloat(pipeHeight),
        }),
      });

      const data = await res.json();
      if (data.success) {
        alert("✅ Pipe drawn successfully!");
      } else {
        alert(`❌ Failed to draw pipe: ${data.error}`);
      }
    } catch {
      alert("⚠️ Could not connect to the Application.");
    }
  };

  const [values, setValues] = useState({
    OD: "",
    Thickness: "",
    Length: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (key, value) => {
    setValues((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const pad = (num) => String(num).padStart(2, "0");

    const now = new Date();
    const year = now.getFullYear();
    const month = pad(now.getMonth() + 1);
    const day = pad(now.getDate());
    const hour = pad(now.getHours());
    const minute = pad(now.getMinutes());
    const second = pad(now.getSeconds());

    const saveFile = `pipe_${year}-${month}-${day}_${hour}-${minute}-${second}.ipt`;

    setLoading(true);

    const requestBody = {
      templateFile: "SamplePart.ipt",
      saveAs: `C:\\Inventor Web\\${saveFile}`,
      parameters: Object.fromEntries(
        Object.entries(values)
          .filter(([_, v]) => v !== "")
          .map(([k, v]) => [k, parseFloat(v)])
      ),
    };

    try {
      const res = await fetch(`${baseUrl}/generate-part`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });
//eslint-disable-next-line
      const data = await res.json();
    } catch (err) {
      console.error(err);
      setMessage(" Failed to connect to the backend.");
    } finally {
      setLoading(false);
    }
  };

  //#endregion API Calls

  const [activetab, setActiveTab] = useState("DrawCircle");
  const toggleTab = (tab) => {
    if (activetab !== tab) setActiveTab(tab);
  };

  return (
    <div>
      <div className="headers" sticky>
        <div className="d-flex align-items-center justify-content-start">
          <img src={logo} alt="autodesk" height="100px" />
        </div>
      </div>
      {showInstallMsg && showContent && (
        <div
          style={{
            backgroundColor: "#fff3cd",
            color: "#856404",
            padding: "10px",
            margin: "20px auto",
            marginTop: "75px",
            width: "60%",
            border: "1px solid #ffeeba",
            borderRadius: "5px",
            textAlign: "center",
          }}
        >
          ⚠️ Kindly download and install the one-time setup file to continue.
          <Button
            color="warning"
            outline
            className="btndwn"
            onClick={downloadAgent}
            style={{ width: "auto", marginLeft: "8px", fontWeight: "bold" }}
          >
            ⬇️ Download one-time Setup
          </Button>
        </div>
      )}

      {!showContent && (
        <Card className="shadow-lg border-0 rounded-lg login-cards">
          <CardBody className="p-4">
            <Form>
              <FormGroup className="mb-4">
                <Input
                  id="password"
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={passwordInput}
                  onChange={(e) => {
                    const value = e.target.value;
                    setPasswordInput(value);
                    if (value.length === 4) {
                      password(value);
                    }
                  }}
                  className="form-control-lg"
                  style={{
                    borderColor: "#3276f2",
                    borderWidth: "2px",
                    borderRadius: "8px",
                  }}
                  maxLength={4}
                  required
                />
              </FormGroup>

              <div className="d-grid">
                <Button
                  color="primary"
                  size="lg"
                  type="submit"
                  disabled={!passwordInput.trim() || showContent}
                  className="rounded-pill fw-bold"
                  style={{
                    backgroundColor: "#3276f2",
                    borderColor: "#3276f2",
                    padding: "12px 0",
                  }}
                  onClick={() => password(passwordInput)}
                >
                  {showContent ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Logging in...
                    </>
                  ) : (
                    "Enter"
                  )}
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      )}

      <Row className="mt-3 content">
        {showContent && (
          <>
            <Col md={2}>
              <div className="side-list">
                <Button
                  style={{
                    color: "white",
                    backgroundColor: "#194270",
                    border: "2px solid",
                    marginTop: "25px",
                    padding: "15px",
                    marginLeft: "15px",
                    fontSize: "1.2rem",
                  }}
                  block
                  outline
                  onClick={() => {
                    toggleTab("DrawCircle");
                  }}
                >
                  Draw Circle
                </Button>
                <Button
                  style={{
                    color: "white",
                    backgroundColor: "#194270",
                    border: "2px solid",
                    marginTop: "25px",
                    padding: "15px",
                    marginLeft: "15px",
                    fontSize: "1.2rem",
                  }}
                  block
                  outline
                  onClick={() => {
                    toggleTab("DrawRect");
                  }}
                >
                  Draw Rectangle
                </Button>
                <Button
                  style={{
                    color: "white",
                    backgroundColor: "#194270",
                    border: "2px solid",
                    marginTop: "25px",
                    padding: "15px",
                    marginLeft: "15px",
                    fontSize: "1.2rem",
                  }}
                  block
                  outline
                  onClick={() => {
                    toggleTab("DrawCyclinder");
                  }}
                >
                  Draw Cyclinder
                </Button>
                <Button
                  style={{
                    color: "white",
                    backgroundColor: "#194270",
                    border: "2px solid",
                    marginTop: "25px",
                    padding: "15px",
                    marginLeft: "15px",
                    fontSize: "1.2rem",
                  }}
                  block
                  outline
                  onClick={() => {
                    toggleTab("Drawpipe");
                  }}
                >
                  Draw Hollow Pipe
                </Button>
                <Button
                  style={{
                    color: "white",
                    backgroundColor: "#194270",
                    border: "2px solid",
                    marginTop: "25px",
                    padding: "15px",
                    marginLeft: "15px",
                    fontSize: "1.2rem",
                  }}
                  block
                  outline
                  onClick={() => {
                    toggleTab("EditParameters");
                  }}
                >
                  Edit Part Parameters
                </Button>
              </div>
            </Col>
            <Col md={8} className="main-form">
              <Card
                className=""
                style={{
                  margin: "0 auto",
                  marginTop: "50px",
                }}
              >
                <TabContent activeTab={activetab}>
                  <TabPane tabId="Home"></TabPane>

                  <TabPane tabId="Status">
                    <CardBody className="card-bodys">
                      <div className="download">
                        <Button
                          color="info"
                          outline
                          className="btncheck"
                          onClick={checkAgent}
                          style={{ width: "auto" }}
                        >
                          🔍 Check Application Status
                        </Button>
                        <Button
                          color="info"
                          outline
                          className="btncheck"
                          onClick={checkInventor}
                          style={{ width: "auto" }}
                        >
                          🔍 Check Inventor
                        </Button>
                      </div>

                      <div className="status">{agentStatus}</div>

                      <hr />

                      <div className="launch">
                        <Button
                          color="success"
                          outline
                          className="btnlaunch"
                          onClick={launchInventor}
                          style={{ width: "auto" }}
                        >
                          Launch Inventor
                        </Button>
                      </div>
                      <div className="status">{invStatus}</div>
                    </CardBody>
                  </TabPane>

                  <TabPane tabId="DrawCircle">
                    <CardBody
                      className="card-bodys"
                      style={{
                        background: "linear-gradient(90deg, #3d9d93, #194270)",
                        border: "0px solid ",
                      }}
                    >
                      <FormGroup row>
                        <Label sm={6} md={4}>
                          Enter diameter value (mm):
                        </Label>
                        <Col sm={6} md={4}>
                          <Input
                            type="number"
                            value={drawc || ""}
                            onChange={(e) => setDrawC(e.target.value)}
                            placeholder="e.g., 100"
                          />
                        </Col>
                      </FormGroup>
                      <div className="d-flex align-items-center justify-content-center">
                        <Button color="primary" onClick={drawCircle}>
                          Draw Circle
                        </Button>
                      </div>
                    </CardBody>
                  </TabPane>

                  <TabPane tabId="DrawRect">
                    <CardBody
                      className="card-bodys"
                      style={{
                        background: "linear-gradient(90deg, #3d9d93, #194270)",
                      }}
                    >
                      <h5 className="mb-3">Draw Rectangle</h5>
                      <FormGroup row>
                        <Label sm={6} md={4}>
                          Width (mm):
                        </Label>
                        <Col sm={6} md={4}>
                          <Input
                            type="number"
                            value={width}
                            onChange={(e) => setWidth(e.target.value)}
                            placeholder="e.g., 100"
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label sm={6} md={4}>
                          Height (mm):
                        </Label>
                        <Col sm={6} md={4}>
                          <Input
                            type="number"
                            value={height}
                            onChange={(e) => setHeight(e.target.value)}
                            placeholder="e.g., 50"
                          />
                        </Col>
                      </FormGroup>

                      <div className="d-flex align-items-center justify-content-center">
                        <Button color="primary" onClick={drawRectangle}>
                          Draw Rectangle
                        </Button>
                      </div>
                    </CardBody>
                  </TabPane>

                  <TabPane tabId="DrawCyclinder">
                    <CardBody
                      className="card-bodys"
                      style={{
                        background: "linear-gradient(90deg, #3d9d93, #194270)",
                      }}
                    >
                      <h5 className="mb-3">Draw Cylinder</h5>
                      <FormGroup row>
                        <Label sm={6} md={4}>
                          Diameter (mm):
                        </Label>
                        <Col sm={6} md={4}>
                          <Input
                            type="number"
                            value={cylDiameter}
                            onChange={(e) => setCylDiameter(e.target.value)}
                            placeholder="e.g., 50"
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label sm={6} md={4}>
                          Height (mm):
                        </Label>
                        <Col sm={6} md={4}>
                          <Input
                            type="number"
                            value={cylHeight}
                            onChange={(e) => setCylHeight(e.target.value)}
                            placeholder="e.g., 100"
                          />
                        </Col>
                      </FormGroup>
                      <div className="d-flex align-items-center justify-content-center">
                        <Button color="primary" onClick={drawCylinder}>
                          Draw Cylinder
                        </Button>
                      </div>
                    </CardBody>
                  </TabPane>

                  <TabPane tabId="Drawpipe">
                    <CardBody
                      className="card-bodys"
                      style={{
                        background: "linear-gradient(90deg, #3d9d93, #194270)",
                      }}
                    >
                      <h5 className="mb-3">Draw Hollow Pipe</h5>
                      <FormGroup row>
                        <Label sm={6} md={4}>
                          Outer Diameter (mm):
                        </Label>
                        <Col sm={6} md={4}>
                          <Input
                            type="number"
                            value={outerDia}
                            onChange={(e) => setOuterDia(e.target.value)}
                            placeholder="e.g., 100"
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label sm={6} md={4}>
                          Inner Diameter (mm):
                        </Label>
                        <Col sm={6} md={4}>
                          <Input
                            type="number"
                            value={innerDia}
                            onChange={(e) => setInnerDia(e.target.value)}
                            placeholder="e.g., 60"
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label sm={6} md={4}>
                          Height (mm):
                        </Label>
                        <Col sm={6} md={4}>
                          <Input
                            type="number"
                            value={pipeHeight}
                            onChange={(e) => setPipeHeight(e.target.value)}
                            placeholder="e.g., 150"
                          />
                        </Col>
                      </FormGroup>
                      <div className="d-flex align-items-center justify-content-center">
                        <Button color="primary" onClick={drawPipe}>
                          Draw Hollow Pipe
                        </Button>
                      </div>
                    </CardBody>
                  </TabPane>

                  <TabPane tabId="EditParameters">
                    <CardBody
                      className="card-bodys"
                      style={{
                        background: "linear-gradient(90deg, #3d9d93, #194270)",
                      }}
                    >
                      <h4>Create New Part File</h4>
                      <Form onSubmit={handleSubmit}>
                        {Object.keys(values).map((key) => (
                          <FormGroup row key={key}>
                            <Label className="text-end" sm="6" md="4">
                              {key}:
                            </Label>
                            <Col sm="6" md="3">
                              <Input
                                type="number"
                                step="any"
                                value={values[key]}
                                onChange={(e) =>
                                  handleChange(key, e.target.value)
                                }
                              />
                            </Col>
                          </FormGroup>
                        ))}
                        <div className=" d-flex justify-content-center">
                          <Button color="primary">
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm mr-2"
                                  role="status"
                                  style={{
                                    marginRight: "5px",
                                    fontWeight: "900",
                                  }}
                                />
                                Please wait generating part file...
                              </>
                            ) : (
                              "Create Part File"
                            )}
                          </Button>
                        </div>
                      </Form>

                      {message && (
                        <Alert
                          className="mt-3"
                          color={message.includes("✅") ? "success" : "danger"}
                        >
                          {message}
                        </Alert>
                      )}
                    </CardBody>
                  </TabPane>
                </TabContent>
              </Card>
            </Col>
          </>
        )}
      </Row>
    </div>
  );
};

export default InventorControlPanel;
